/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { useLocation, useNavigate } from 'react-router-dom';

/* Helpers, constants, custom methods, internal libraries */
import { useReportsService  } from "../../../../services/reportsService";
import { useAnalytics } from "../../../../hooks/useAnalytics";
import { PAGE_TITLES } from "../../../../constants/appConstants";

/* Components */
import HotelBookingGrid from "./hotelBookingGrid";
import { useHotelReportsService } from '../../../../services/hotelReportsService';
import HotelBookingReportsFilters from '../hotelBookingReoprtFilters';

/* Styles */
import styles from "./styles.js"


const HotelBookingsTab = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const location = useLocation();
  const navigate = useNavigate();
  const { initAnalytics } = useAnalytics();

  const [gridOptions, setGridOptions] = useState(() => {
    const initialPage = location.pathname.includes('/booking-hotel')
      ? new URLSearchParams(location.search).get('page') || 1
      : 1;
    return {
      reportType: "hotel-bookings",
      gridName: "hotelBookingsGrid",
      page: +initialPage,
      bookedStartDate: "",
      bookedEndDate: "",
      travelStartDate: "",
      travelEndDate: ""
    };
  });

  const { hotelReportsResponse, getHotelReportsList } = useHotelReportsService();

  const enableDownloadButton = hotelReportsResponse?.results?.dataItems.length > 0;


  useEffect(() => {
    getHotelReportsList(gridOptions);
    gridOptions.page > 1 ? navigate(`/app/reports/hotel-bookings?page=${gridOptions.page}`) : navigate(`/app/reports/hotel-bookings`)
  }, [gridOptions]);

  const onRowClick = row => {}

  return (
    <div className={classes.bookingsTab}>
      <HotelBookingReportsFilters
        response={hotelReportsResponse}
        gridOptions={gridOptions}
        setGridOptions={setGridOptions}
        type="REPORTS"
        enableDownloadButton={enableDownloadButton}
      />
      <HotelBookingGrid
        bookingsResponse={hotelReportsResponse}
        gridOptions={gridOptions}
        setGridOptions={setGridOptions}
        onRowClick={onRowClick}
      />
    </div>
  )
}

export default HotelBookingsTab;
